export default __webpack_public_path__ + "locales/es/Webhooks.json?hash=5ce8692de04ae0bf53413374dd64fc04";